export default __webpack_public_path__ + "static/media/bg-referencement.a38e8f9b.webp";